module.exports = __webpack_public_path__ + "static/media/flag-tr.58bca5f6.webp";